import { render, staticRenderFns } from "./RegisteredUserPage.vue?vue&type=template&id=8e550c06&"
import script from "./RegisteredUserPage.vue?vue&type=script&lang=js&"
export * from "./RegisteredUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports